import { render, staticRenderFns } from "./burger-menu.vue?vue&type=template&id=474b7dc1"
import script from "./burger-menu.vue?vue&type=script&lang=js"
export * from "./burger-menu.vue?vue&type=script&lang=js"
import style0 from "./burger-menu.vue?vue&type=style&index=0&id=474b7dc1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
